//visualizar svg control + shift + p
//escrever svg
export function IconTooMeWhite({
    className,
    onClick = null
}) {
    return <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 3000 1096" width="749" height="274" onClick={onClick} className={className}>
        <path transform="translate(2300,113)" d="m0 0h88l20 5 9 5 8 8 5 13 2 15 3 22 1 27 2 11 1 3 1 33 1 7 2 7v14l1 16 2 8 1 2 1 32 3 9v18l2 18 2 3 1 32 3 9v13l1 20 2 8 1 2 1 31 2 7 1 3 1 32 1 8 2 5 1 35 3 10v19l2 32 2 5 1 38 2 5 1 8v41l-4 10-6 8-8 6-6 2h-115l-14-7-5-5-8-16-2-29-2-10-1-27-1-14-2-7-1-37-1-13-2-6-1-34-2-16-1-2-1-38-2-12-1-2-1-32-1-15-2-5-1-30-1-17-3-16v-7l-12 23-8 17-8 18-12 25-8 17-6 13-11 24-12 25-13 28-12 25-11 20-12 22-6 8-9 8-17 8-10 2-10 3h-22l-9-4-3 1-18-8-9-7-10-11-10-17-12-21-11-25-15-31-9-21-13-27-6-15-14-29-6-15-9-19-9-21-12-25-1-1-1 19-4 20-1 26-3 15-1 23-3 12-1 28-2 6-1 7-1 23-2 6-1 7-1 24-2 9-1 9-1 20-3 12-1 27-3 11-1 23-2 5-1 6-1 24-3 9-1 11-7 14-8 7-12 4h-117l-10-7-6-7-2-6v-33l2-5 2-26 2-9 1-10 1-26 2-5 1-11 1-20 2-6 1-7 1-23 2-5 1-8 1-19 2-6 1-7 1-19 2-5 2-28 3-9 1-18 3-10 1-14 2-6 1-7 1-19 2-5 2-23 2-5 1-8 1-19 2-6 2-22 2-5 1-6 1-16 3-10 1-19 2-5 1-7 1-20 3-9 1-15 2-6 2-29 2-5 3-13 5-10 6-7 10-7 7-3h116l10 4 10 7 8 10 10 17 11 24 7 15 12 26 36 72 15 33 8 17 23 46 7 16 4 8 11 23 3 7 2 1 1-6 5-11 10-19 11-23 8-16 11-23 10-19 10-21 37-74 8-19 8-16 10-21 8-16 10-19 9-11 10-8 9-4 16-3z" fill="#fff" />
        <path transform="translate(1590,131)" d="m0 0 6 1 11 15 13 21 14 25 12 21 15 26 6 10 15 26 13 24 8 16 2 7v9l-3 5-5 4-9 2-20 1-30 5-35 10-53 15-17 3-16 1 13 13 4 3 6-1 15-3 9-3 5-2 13-1 4 3 5 9 3 5 7 20 5 15 3 13 2 5 1 22 2 6 1 2v45l-3 12-1 15-3 10-3 14-6 21-7 19-9 20-6 10-6 11-10 16-8 10-6 8-7 7-5 6-8 7-9 9-22 16-13 8-25 13-20 8-30 10-7 1-12 3-11 2-2 1-19 1h-68l-10-3-5-1h-9l-7-4-6-1-26-9-15-7-18-8-13-8-11-7-17-13-10-9-27-27-9-11-11-16-8-13-14-27-7-19-3-8-2-5-1-9-3-7-2-14-2-6-2-28-1-10-1-5 1-1 2-24 1-22 3-8 1-11 13-38 7-17 5-9 8-14 7-10 3-5h2l2-4 26-26h2l2-4 5-3 7 1 2 2v12l-1 13 3 7 7 7 4-1 11-7 14-9 23-12 16-8 8-2 4-2 7-1 5-3 9-1 7-3 13-1 6-3 32-2 4-2h35l5 2 23 2 6 3 13 1 7 3 7 2 24 8 19 9 16 9 17 10 7 6 3 3 2-6 9-16 7-10 2-6-9-6-23-12-15-7-25-9-27-7-27-5-18-2-16-1h-30l-30 2-25 4-28 7-29 10-18 8-22 12-10 7-5 1-1-1 1-7 8-11 7-7 5-6 8-7 7-7 14-11 16-12 18-12 22-12 31-15 24-9 29-9 34-8 31-5 12-1h52l17 2 25 5 20 6 19 7 6 3 6-23 7-33 2-10 4-8zm-263 249-6 2h-11l-7 4-7 1-7 3-11 4-11 7-9 7-13 13-7 11-5 8-6 14-4 12-2 11-2 4-1 17-2 7v24l2 5 1 17 9 26 9 16 10 13 16 16 10 7 15 8 17 6 8 2h43l19-6 16-8 11-6 14-11 8-9 10-15 6-13 5-14 3-11 1-16v-46l-2-10-1-1-1-10-3-6-2-8-10-21-10-15-9-10-11-8-10-7-18-8-9-3-18-1-4-2z" fill="#FEFEFE" />
        <path transform="translate(69,33)" d="m0 0h499l16 1 14 4 7 4 7 6 7 10 3 6 1 6v93l-2 8-4 9-7 9-8 6-10 4-8 1-58 1-3 3-3-2h-8l-4 1-2-2-87-1v539l-1 10-8 14-6 5-11 5-18 5h-53l-2-1-41-1-15-2-12-9-5-6-6-13-1-27-1-519h-172l-12-2-10-6-9-9-7-14v-103l6-12 9-10 8-6 12-3z" fill="#fff" />
        <path transform="translate(736,236)" d="m0 0 47 1 7 2 15 2 23 6 22 8 19 8 16 9 15 9 14 10 13 10 7 7 7 6v2l4 2 7 8 8 9 8 10 11 15 12 21 11 22 6 15 7 21 2 10 2 6 1 13 3 8v66l-3 9-2 21-2 5-2 11-8 23-9 22-8 16-8 13-9 13-9 12-15 16-17 17-8 7-14 10-19 12-14 8-9 5-16 6-6 3-9 3-13 4-6 1-5 1-9 3-13 2-8 2h-73l-6-3-14-1-10-4-4-1-1 2-6-2-5-3-7-1-5-3h-5l-12-6-13-5-16-8-15-8-15-10-12-9-13-12-6-5-7-8-12-12-10-13-13-20-12-23-8-20-8-24-5-20-1-17-3-8v-62l3-7 1-15 3-9 4-16 9-27 9-20 9-16 10-15 9-13 8-9 8-11h2l2-4 12-12h2l2-4 17-13 11-8 20-13 15-8 17-8 7-2 4-2 8-2 4-2 10-1 6-3 12-1 8-3zm-2 143-8 3h-8l-9 4-10 3-16 9-16 13-3 3v2h-2l-8 11-6 8-8 15-5 12-3 12-5 23v40l5 21 9 25 7 12 11 13 3 4h2l1 3 16 12 19 10 10 4 10 2 7 2h35l7-3 9-1 11-5 17-8 11-7 13-12v-2h2l7-8 7-11 7-14 5-16 3-10 1-23 1-7-2-8v-28l-3-7-2-11-5-15-10-19-9-12-12-12-16-11-19-9-4-1-5-2-12-3-9-1z" fill="#fff" />
        <path transform="translate(2721,237)" d="m0 0h62l9 3 11 1 9 3 12 3 12 4 12 5 15 8 18 11 10 8 8 6 5 4v2l4 2 8 8 7 8 11 14 8 12 9 15 11 23 8 20 3 10 4 15 2 5v8l4 11 1 18 2 7 1 7v18l-1 25-2 4-2 11-6 10-7 6-13 6-5 1h-296l4 14 5 15 9 17 12 14 11 10 12 7 18 8 12 4 9 1 8 3h55l6-3 14-1 6-3 10-1 15-7 9-3 35-17 10-5 5 2 10 7 8 7 7 11 7 9 9 14 6 13 4 12v15l-6 11-6 7-8 7-12 9-19 12-16 8-21 10-10 3-9 3-7 3-8 2-3 2h-11l-7 3-10 1-15 2-3 1-55 1-5-2-17-2-9-1-3-2-9-1h-5l-6-3-18-6-14-6-13-5-17-9-24-16-16-13-10-8-7-7-7-9-9-10-14-19-12-20-9-19-8-20-4-12-2-13-2-5-2-18-2-6v-89l3-11 2-12 7-25 10-28 13-27 7-12 6-9 6-8 11-12 6-9 16-14 11-9 9-7 14-10 22-12 17-8 9-3 13-4 2-1 9-1 7-3 15-2zm30 125-13 1-17 5-12 5-15 10-11 11-8 11-10 19-7 21v3l9 1h172l4-2-2-13-5-15-8-16-7-11-7-8-10-7-6-5-18-6-10-3-9-1z" fill="#fff" />
        <path transform="translate(1350,917)" d="m0 0h20l12 3 11 6 7 7 4 5 2 4 4-5 7-8 10-7 12-4 6-1h17l13 3 12 6 10 9 7 12 3 11 1 8 1 95-3 2h-32l-1-1-1-34-1-57-2-9-6-9-8-5-4-1h-17l-7 3-5 4-5 8-2 10-1 90-1 1h-33l-1-1-1-76-1-19-4-10-4-5-10-5-12-1-10 2-6 4-6 7-4 13-1 53v35l-2 3h-33l-1-2v-141h32l2 2v16l5-5 5-6 14-8z" fill="#fff" />
        <path transform="translate(2426,863)" d="m0 0h33l3 1 1 196-1 2-3 1h-17l-8-2-2-4-2-12-10 10-10 6-13 4-7 1h-17l-12-2-12-5-10-7-10-10-8-15-4-14-2-11v-22l4-18 5-12 6-9 4-5 10-8 14-7 14-3h22l12 3 11 6 9 9zm-42 83-11 3-8 6-6 7-5 12-2 13 1 17 4 13 6 8 8 7 10 4 5 1h10l13-4 9-7 6-10 3-10 1-18-1-12-5-13-6-8-9-6-11-3z" fill="#fff" />
        <path transform="translate(2174,917)" d="m0 0h22l16 3 9 4 10 6 7 7 8 16 2 11 1 63 3 10 9 2 1 1-1 21-2 2h-28l-7-4-6-7-4-6-7 7-10 7-11 4-9 2h-22l-13-4-9-6-7-7-6-12-1-3v-20l5-13 8-10 11-7 12-5 19-4 13-1h24v-10l-3-9-5-6-7-3-7-1h-11l-12 3-11 7-7 8-5-2-17-5-6-2 1-5 6-10 7-8 14-8 13-4zm18 81-18 2-10 4-5 4-4 8-1 3v7l4 8 5 4 3 1h20l10-4 8-6 5-8 4-13 1-9-6-1z" fill="#fff" />
        <path transform="translate(619,917)" d="m0 0h24l17 3 14 6 12 9 8 9 6 10 4 11 3 17v18l-4 20-4 10-9 13-4 5-9 7-12 6-15 4-15 2-19-1-16-4-12-6-9-7-7-7-8-13-5-13-2-9-1-10v-16l2-11 4-12 5-10 8-11 9-8 16-8 12-3zm5 28-11 3-8 6-7 11-3 8-2 15 1 16 3 11 4 8 8 9 10 5 3 1h20l10-4 10-9 5-10 2-10v-26l-3-13-6-10-9-7-7-3-6-1z" fill="#fff" />
        <path transform="translate(1079,917)" d="m0 0h24l15 3 16 7 13 11 9 12 6 14 3 16v21l-3 17-7 16-8 11-10 9-14 7-9 3-22 3h-9l-19-3-15-6-11-8-7-7-7-11-5-13-3-12-1-15 2-21 6-18 7-11 8-9 14-9 15-5zm5 28-10 2-8 5-7 8-5 12-2 10v21l3 11 5 10 5 6 10 6 6 2h18l10-4 6-4 5-5 5-9 3-16v-20l-3-14-7-11-8-6-8-3-8-1z" fill="#fff" />
        <path transform="translate(2589,917)" d="m0 0h26l15 3 13 5 11 8 8 8 7 11 5 12 3 14v24l-3 17-5 12-7 11-5 6-11 8-8 4-12 4-12 2h-26l-10-2-13-5-10-6-10-9-8-11-6-15-3-13-1-10v-10l2-14 6-18 9-14 8-8 14-8 12-4zm6 28-9 2-9 6-6 7-5 12-2 13v11l3 17 6 12 7 7 10 5 3 1h18l11-4 8-6 6-8 3-9 1-6v-28l-4-13-6-9-8-6-8-3-6-1z" fill="#FEFEFE" />
        <path transform="translate(1635,917)" d="m0 0h13l16 3 12 5 11 8 8 8 7 11 6 16 2 9 1 12v12l-1 1h-103l2 10 4 10 7 9 11 6 5 1h14l10-2 8-4 5-5 2-4h11l21 2-1 7-6 10-7 8-10 7-12 5-18 4h-24l-16-4-13-7-10-9-7-8-8-16-4-15v-28l4-16 5-12 8-12h2l2-4 12-9 11-5 12-3zm-1 27-9 3-9 8-7 14-2 9 1 1h67l1-5-5-13-6-9-8-6-8-2z" fill="#fff" />
        <path transform="translate(888,917)" d="m0 0h21l12 3 10 5 10 9 7 10 5 13 2 17v87l-6 2-29-1-1-1-1-87-3-12-6-10-7-4-4-1h-19l-9 4-5 5-4 6-3 9-1 8-1 83-1 1h-31l-3-1-1-136 1-6h30l1 1 1 14 1 2h2l2-4 8-7 14-7z" fill="#FEFEFE" />
        <path transform="translate(1979,917)" d="m0 0h25l14 3 16 7 13 11 8 11 6 12v2l-7 1-28 1-3-3-6-8-5-4-7-3-6-1h-14l-11 3-4 3h-2v2h-2l-6 12-3 11v28l5 15 6 8 6 5 11 4h17l10-4 8-7 6-12 2-1h31l4 1-2 6-5 12-7 10-9 10-9 6-15 5-9 2-9 1h-17l-12-2-14-5-10-6-11-11-7-11-6-16-2-11v-24l2-12 5-14 7-12 7-8h2v-2l11-7 12-5z" fill="#FEFEFE" />
        <path transform="translate(429,882)" d="m0 0h35l1 1v37h38l1 1-1 25-2 1h-36l1 56 1 18 3 11 4 2 6 2 18 2 3 3-3 20-2 3h-28l-15-3-10-5-9-10-4-10-2-13v-77l-3 1h-10l-5-2-1-4v-21h19v-37z" fill="#FEFEFE" />
        <path transform="translate(1854,917)" d="m0 0 12 1 3 2-2 24-2 6h-19l-12 3-10 6-7 9-3 7-1 5-1 17-1 65-1 1h-35l-1-4v-139l3-1 29 1 1 1 1 22 5-5 7-8 14-9 10-3z" fill="#fff" />
        <path transform="translate(626,858)" d="m0 0h8l10 5 14 15 10 11 4 6v3l-26 1-8-8-7-8v-2l-8 7-8 10-5 1-19-1-1-4 10-13 9-10 7-8 6-4z" fill="#FEFEFE" />
        <path transform="translate(2287,383)" d="m0 0" fill="#fff" />
    </svg>
}
export function IconTooMe({
    className,
    onClick = null,
    color = '#F5F5F5'
}) {
    return <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2048 709" width="753" height="261" onClick={onClick} className={className} >
        <path transform="translate(0)" d="m0 0h2048v709h-2048z" fill={color} />
        <path transform="translate(1559,61)" d="m0 0h70l10 3 7 6 4 9 2 12 8 92 14 143 8 95 4 50 1 8v10l-4 10-4 5-6 3-8 1h-64l-10-2-8-5-4-7-2-10-14-186-5-59v-6l-3 3-19 39-15 33-18 38-16 34-14 27-7 11-9 7-13 5-6 1h-17l-16-4-9-6-8-9-11-19-13-28-9-19-15-33-16-36-17-36-7-15h-1l-7 68-12 114-9 79-3 10-4 6-5 3-15 2h-63l-9-3-6-5-2-7v-11l12-110 9-71 8-56 7-54 7-49 8-58 4-10 5-6 9-5 8-1h62l11 1 10 6 6 7 9 17 13 28 15 30 13 28 24 49 13 28 11 23 3 5 2 1 2-6 9-17 13-28 33-66 11-23 12-24 13-28 10-19 9-8 10-4z" fill="#D35C12" />
        <path transform="translate(1082,70)" d="m0 0 5 3 10 15 16 28 13 23 13 22 16 29 3 7v11l-4 4-13 2-19 2-20 5-35 10-19 5h-17l-7-3-3-2 14 14 8 6 11-2 17-5 5 1 4 5 6 15 5 17 3 19 1 9v33l-4 25-6 22-9 22-8 15-11 16-9 11-17 17-15 11-17 10-20 9-22 7-26 5-11 1h-28l-20-2-21-5-20-7-25-12-16-11-13-11-13-13-8-9-12-17-12-23-8-22-5-22-2-14-1-20 2-23 4-21 9-27 9-19 9-13 9-10 15-14 3-2h3v9l-1 10 5 8 2 3 6-2 14-9 23-12 16-6 19-5 26-4h39l26 5 22 7 14 6 19 11 8 5 2 3h2l7-14 7-11 1-3-5-2-20-11-21-8-17-5-20-4-15-2h-45l-22 3-21 5-26 9-19 10-10 6h-3l1-5 5-7h2l1-3h2v-2l5-4 1-2h2l1-3 11-9 12-9 15-10 20-11 21-9 20-7 22-6 28-5 7-1 27-1 20 1 24 5 16 5 14 5 1-7 6-27 3-13z" fill="#D35C12" />
        <path transform="translate(493,143)" d="m0 0h16l28 2 19 4 24 8 22 11 18 12 11 9 18 18 11 14 12 19 9 19 7 21 4 20 2 25-1 22-5 30-8 24-10 21-12 18-12 14-9 10-14 12-15 10-21 11-21 8-28 7-18 2h-19l-22-2-23-5-24-8-18-8-18-10-17-13-12-11-7-8-11-15-8-13-10-21-8-26-4-25-1-11v-13l2-25 5-22 6-18 9-20 12-19 11-14 13-14 8-7 14-11 20-12 12-6 27-9 15-3z" fill="#D35C12" />
        <path transform="translate(48,6)" d="m0 0h347l10 2 9 6 5 7 2 7v66l-3 8-7 8-10 5-117 1-1 49v311l-1 14-4 7-6 5-9 4-8 1h-55l-15-1-10-5-6-7-3-7-1-6-1-365-123-1-10-5-6-7-3-9v-68l3-7 6-7 8-4z" fill="#D45C12" />
        <path transform="translate(1856,144)" d="m0 0h30l18 3 19 5 15 6 19 11 13 10 18 18 10 14 9 16 9 21 6 19 4 19 2 18v30l-3 12-9 10-5 2-207 1 3 15 6 14 8 11 4 5 11 8 16 8 13 4 11 2h29l22-4 19-6 26-12 8-4h5l9 7 8 10 9 14 5 10 2 9-1 10-8 10-14 11-22 12-16 7-22 7-21 4-17 2h-25l-24-3-21-5-24-9-19-10-13-9-10-8-9-8-7-8-12-15-13-22-9-22-5-20-3-22v-51l3-19 7-24 9-21 9-17 12-16 11-12 7-7 14-11 18-11 17-8 19-6 19-4z" fill="#D35C12" />
        <path transform="translate(503,236)" d="m0 0h11l15 3 15 6 12 8 12 11 9 13 6 14 4 14 2 16v23l-2 13-6 18-9 15-7 8h-2v2l-8 6-8 5-19 8-10 2h-24l-16-4-16-8-11-9-7-7-9-13-5-11-5-19-1-5v-24l4-21 7-19 8-12 11-12 10-8 16-8 16-4z" fill={color} />
        <path transform="translate(899,237)" d="m0 0h15l15 3 13 5 12 7 12 11 9 13 6 12 5 16 2 11 1 12v12l-3 21-6 17-7 12-9 11-12 9-16 8-10 3-15 2h-9l-15-2-12-4-16-9-15-15-9-14-5-11-4-15-1-5v-28l4-21 6-16 6-11 11-13 12-9 12-6 12-4z" fill={color} />
        <path transform="translate(1082,70)" d="m0 0 5 3 10 15 16 28 13 23 13 22 16 29 3 7v11l-4 4-13 2-19 2-20 5-35 10-19 5h-17l-7-3-5-6 3-3 6-12 7-11 1-3-5-2-20-11-21-8-17-5-20-4-15-2h-45l-22 3-21 5-26 9-19 10-10 6h-3l1-5 5-7h2l1-3h2v-2l5-4 1-2h2l1-3 11-9 12-9 15-10 20-11 21-9 20-7 22-6 28-5 7-1 27-1 20 1 24 5 16 5 14 5 1-7 6-27 3-13z" fill="#2C786F" />
        <path transform="translate(1650,568)" d="m0 0h24v134h-19l-1-1v-10h-3l-2 4-9 6-8 3-16 1-12-2-12-6-8-8-7-14-3-13v-15l3-14 7-13 10-9 11-5 12-2h8l12 3 9 6 2 4h3l-1-3z" fill="#2C786F" />
        <path transform="translate(420,604)" d="m0 0h19l15 4 12 7 7 9 5 11 3 16-1 14-5 16-9 12-8 6-14 5-7 1h-14l-12-2-11-5-8-6-7-10-5-13-1-5v-21l4-13 7-11 5-5 8-5 7-3z" fill="#2C786F" />
        <path transform="translate(732,604)" d="m0 0h20l12 3 9 5 8 7 7 11 2 5 2 9v20l-3 12-6 11-6 7-10 6-11 4-9 1h-14l-10-2-9-3-11-8-6-9-4-10-2-9v-18l2-10 5-12 7-8 8-6 14-5z" fill="#2C786F" />
        <path transform="translate(1760,604)" d="m0 0h19l13 3 11 6 7 7 7 12 3 12v21l-3 12-6 11-7 7-10 6-10 3-9 1h-11l-13-2-14-7-7-6-6-10-4-13-1-5v-17l4-14 5-10 9-9 8-4 9-3z" fill="#2C786F" />
        <path transform="translate(923,603)" d="m0 0 10 1 10 4 6 4 6 7v2l12-12 10-4 5-1h13l13 4 8 6 5 7 3 9 1 5v67h-23l-1-58-2-10-7-8-5-2h-12l-6 3-4 5-3 8-1 62h-23l-1-62-3-9-5-5-5-2h-12l-8 4-4 5-2 13-1 56h-23v-96h20l2 3 1 8 7-7 12-6z" fill="#2C786F" />
        <path transform="translate(1475,604)" d="m0 0h19l13 3 9 5 7 8 5 12 1 46 3 7 6 3-1 13-3 2h-14l-7-2-5-6-1-5-5 5-5 4-12 5-6 1h-12l-8-2-8-4-7-8-3-8v-14l6-12 7-6 11-5 15-3 24-1-1-10-3-5-5-3-4-1h-13l-12 6-3 1-2 5-15-5-4-1 1-5 6-9 9-6 12-4z" fill="#2C786F" />
        <path transform="translate(1866,225)" d="m0 0h16l15 4 12 7 11 10 7 11 6 15 3 11v5l-1 1h-128l-2-1 1-9 6-15 8-14 11-11 10-7 14-5z" fill={color} />
        <path transform="translate(1110,604)" d="m0 0h13l12 3 10 6 8 8 6 11 3 8 1 6v15l-70 1 2 9 5 9 8 5 3 1h14l9-4 7-7 18 2 1 5-7 11-13 8-9 3-9 1h-10l-12-2-10-4-9-7-7-10-4-11-2-9v-12l4-18 5-10 8-8 10-6 9-3z" fill="#2C786F" />
        <path transform="translate(603,604)" d="m0 0h16l12 4 8 6 6 10 3 9 1 7v60l-1 2h-22l-1-56-3-13-5-6-7-3h-12l-8 4-5 7-2 5-1 40-1 22h-22v-96h20v12h3l2-4 10-7z" fill="#2C786F" />
        <path transform="translate(1345,604)" d="m0 0h19l14 4 8 5 7 6 6 10 1 6-22 1-4-4-4-5-7-3h-16l-10 5-5 10-1 3v22l3 10 3 4v2l4 2 7 3 11 1 9-3 5-5 7-9 22 1-3 10-6 9-9 9-16 6-18 1-16-3-9-4-9-8-6-10-4-13v-27l4-12 6-9 7-7 10-5z" fill="#2C786F" />
        <path transform="translate(292,580)" d="m0 0h24v26h26v18h-25v47l2 9 4 4 16 2 1 2-2 15h-20l-11-2-9-6-5-10-1-4-1-56-1-1-10-1-1-1v-16l12-1z" fill="#2C786F" />
        <path transform="translate(1257,604)" d="m0 0h10l4 2-2 19-15 1-10 4-7 6-4 9-1 7-1 50h-24v-95l5-1h16l1 15 8-7 7-6 7-3z" fill="#2C786F" />
        <path transform="translate(422,623)" d="m0 0h16l8 4 6 7 3 8 1 6v12l-3 12-4 7-8 6-7 2-13-1-9-5-6-9-2-6-1-7v-12l2-9 6-9 8-5z" fill={color} />
        <path transform="translate(1761,623)" d="m0 0h16l7 3 7 6 4 11 1 5v13l-3 12-4 6-7 5-10 3-10-1-8-4-5-5-4-9-2-8v-13l4-13 6-7z" fill={color} />
        <path transform="translate(732,623)" d="m0 0h17l7 3 8 8 2 4 2 12-1 10-1 9-4 8-8 7-6 2h-15l-8-4-6-8-4-12v-17l4-11 7-8z" fill={color} />
        <path transform="translate(1621,623)" d="m0 0h7l10 3 8 7 4 9 1 4v17l-4 11-5 6-10 5-10 1-4-2-5-1-8-7-4-8-1-4v-21l4-10 8-7z" fill={color} />
        <path transform="translate(1483,659)" d="m0 0h22v8l-4 10-5 6-5 3-4 1h-15l-6-5-1-2v-11l5-6z" fill={color} />
        <path transform="translate(1111,622)" d="m0 0h11l8 3 5 5 4 9 1 6-2 1h-45l1-7 5-10 5-5z" fill={color} />
        <path transform="translate(426,564)" d="m0 0 8 1 6 4 14 16 2 5-1 1h-16l-7-7-3-4h-2l-8 10-2 1h-12l-3-1 1-4 9-11 7-8z" fill="#2C786F" />
    </svg>

}
export function IconChevronRight({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}

        width={size}
        fill={color}
        onClick={onClick}
        viewBox="0 -960 960 960"
    >
        <path d="M504-480 320-664l56-56 240 240-240 240-56-56 184-184Z" />
    </svg>
}
export function IconIOS({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}

        width={size}
        fill={color}
        onClick={onClick}
        viewBox="0 -960 960 960"
    >
        <path d="M160-600v-80h80v80h-80Zm0 320v-240h80v240h-80Zm280 0h-80q-33 0-56.5-23.5T280-360v-240q0-33 23.5-56.5T360-680h80q33 
            0 56.5 23.5T520-600v240q0 33-23.5 56.5T440-280Zm-80-80h80v-240h-80v240Zm200 80v-80h160v-80h-80q-33 0-56.5-23.5T560-520v-80q0-33 
            23.5-56.5T640-680h160v80H640v80h80q33 0 56.5 23.5T800-440v80q0 33-23.5 56.5T720-280H560Z"/>
    </svg>
}
export function IconAndroid({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}

        width={size}
        fill={color}
        onClick={onClick}
        viewBox="0 -960 960 960"
    >
        <path d="M40-240q9-107 65.5-197T256-580l-74-128q-6-9-3-19t13-15q8-5 18-2t16 12l74 128q86-36 180-36t180 36l74-128q6-9 16-12t18 2q10 5 
        13 15t-3 19l-74 128q94 53 150.5 143T920-240H40Zm240-110q21 0 35.5-14.5T330-400q0-21-14.5-35.5T280-450q-21 0-35.5 14.5T230-400q0 21 
        14.5 35.5T280-350Zm400 0q21 0 35.5-14.5T730-400q0-21-14.5-35.5T680-450q-21 0-35.5 14.5T630-400q0 21 14.5 35.5T680-350Z"/>
    </svg>
}
export function IconYoutube({
    className,
    onClick = null,
    size = "19",
    color = "#fff"
}) {
    return <svg fill={color} className={className} onClick={onClick} width={size} height={size} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z" /></svg>
}

export function IconInstagram({
    className,
    onClick = null,
    size = "19",
    color = "#fff"
}) {
    return <svg fill={color} className={className} onClick={onClick} width={size} height={size} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" /></svg>
}

export function IconLinkedin({
    className,
    onClick = null,
    size = "19",
    color = "#fff"
}) {
    return <svg fill={color} className={className} onClick={onClick} width={size} height={size} version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M416 32H31.9C14.3 32 0 46.5 0 64.3v383.4C0 465.5 14.3 480 31.9 480H416c17.6 0 32-14.5 32-32.3V64.3c0-17.8-14.4-32.3-32-32.3zM135.4 416H69V202.2h66.5V416zm-33.2-243c-21.3 0-38.5-17.3-38.5-38.5S80.9 96 102.2 96c21.2 0 38.5 17.3 38.5 38.5 0 21.3-17.2 38.5-38.5 38.5zm282.1 243h-66.4V312c0-24.8-.5-56.7-34.5-56.7-34.6 0-39.9 27-39.9 54.9V416h-66.4V202.2h63.7v29.2h.9c8.9-16.8 30.6-34.5 62.9-34.5 67.2 0 79.7 44.3 79.7 101.9V416z" /></svg>
}
export function IconArrowLeftAlt({
    className,
    size = '24px',
    color = '#000',
    id,
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        id={id}
        width={size}
        fill={color}
        onClick={onClick}
        viewBox="0 -960 960 960"
    >
        <path d="M400-240 160-480l240-240 56 58-142 142h486v80H314l142 142-56 58Z" />
    </svg>
}
export function IconHeadsetMic({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-40v-80h280v-40H600v-320h160v-40q0-116-82-198t-198-82q-116 0-198 82t-82 
            198v40h160v320H200q-33 0-56.5-23.5T120-240v-280q0-74 28.5-139.5T226-774q49-49 
            114.5-77.5T480-880q74 0 139.5 28.5T734-774q49 49 77.5 114.5T840-520v400q0 33-23.5 
            56.5T760-40H480ZM200-240h80v-160h-80v160Zm480 0h80v-160h-80v160ZM200-400h80-80Zm480 0h80-80Z"/>
    </svg>
}

export function IconDownload({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 
            0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
    </svg>
}


export function IconProductNull({
    className,
    onClick = null,
}) {
    return <svg version="1.1" viewBox="0 0 2048 2044" width="554" height="553" xmlns="http://www.w3.org/2000/svg" onClick={onClick} className={className} >
        <path transform="translate(0)" d="m0 0h2048v2044h-2048z" fill="#E0DFDF" />
        <path transform="translate(762,453)" d="m0 0h79l1 1 1 15v19h461l45 1 11 1 5 3 3 4 1 25 1 69v214l-1 67-1 25-3 6-3 2-14 1-42 1h-542l-42-1-20-1-10-2-7-3-1-6-1-23-1-49v-250l1-67 1-9 9-4 13-3 26-3v-13l1-19z" fill="#FEFEFE" />
        <path transform="translate(1022,553)" d="m0 0h38l21 5 24 9 23 12 14 10 13 12 7 7 11 15 9 16 9 19 6 23 2 19v26l-3 19-9 27-8 16-7 11-8 10-12 13-10 9-15 11-13 8-15 7-15 5-20 4-15 2h-21l-32-7-23-8-22-12-13-10-10-9-8-8-12-16-9-15-9-19-5-15-3-16-1-12v-21l2-18 3-14 6-16 8-16 7-12 9-13 12-13 7-7 16-12 18-10 19-8 16-5z" fill="#E0DFDF" />
        <path transform="translate(1027,600)" d="m0 0h31l17 4 13 5 17 9 10 8 13 11 10 13 8 16 6 17 1 6v38l-2 12-6 15-7 13-11 14-12 12-15 10-15 7-20 6-10 2h-28l-19-4-17-6-15-9-10-8-17-17-8-13-7-15-7-26v-22l5-21 5-13 9-16 11-12 7-7 11-9 13-8 11-5 20-6z" fill="#FEFEFE" />
        <path transform="translate(725,1351)" d="m0 0 31 1 1 1 1 64v82l-1 54h-41l-1-1v-119l1-5h-2l-4 20-15 56-8 28-5 19-1 1h-34l-4-9-9-32-11-42-9-37-1-8h-2l1 128-1 1h-40l-1-1-1-71v-129h58l4 9 12 43 20 76v2l2-1 4-17 13-49 11-39 7-21 5-3z" fill="#FEFEFE" />
        <path transform="translate(941,1352)" d="m0 0h57l2 2 10 36 12 44 8 29 4 17 2-1 8-31 16-57 10-35 2-3 5-1h50l1 1v199l-5 1h-36l-1-1v-116l1-8h-2l-3 15-8 32-14 50-8 26-1 1h-33l-4-10-7-24-11-41-9-37-2-8h-2v120l-13 1h-29z" fill="#FEFEFE" />
        <path transform="translate(1596,1352)" d="m0 0h59l7 24 14 52 13 49 1 6 2 1 1-9 13-49 8-28 8-30 5-14 3-2h52l1 2v198l-1 1h-40v-68l1-58-2 1-6 26-9 33-8 30-8 29-2 6-31 1-5-2-5-15-16-64-11-43-2-2 1 125-1 1h-41l-1-1z" fill="#FEFEFE" />
        <path transform="translate(955,1044)" d="m0 0h86l16 2 13 5 11 7 5 4 7 10 4 12 1 9v104l-4 15-7 11-9 9-12 6-16 4-26 2h-69l-1-1v-63z" fill="#FEFEFE" />
        <path transform="translate(1522,1041)" d="m0 0h10l21 3 16 6 10 6 11 11 8 16 2 11 1 13v80l-4 17-8 16-9 10-10 6-24 8-13 2h-14l-18-3-15-5-9-5-10-9-6-7-4-8-4-12-2-25v-43l1-30 2-13 8-16 9-11 8-6 12-6 13-4z" fill="#FEFEFE" />
        <path transform="translate(842,1042)" d="m0 0h32l14 3 14 6 11 8 7 7 8 13 3 9 1 6v92l-3 16-8 16-6 8-8 7-10 5-16 5-18 3h-15l-16-3-12-4-12-6-13-12-6-10-4-13-2-16-1-36 1-50 3-12 6-12 7-9 9-9 16-8 11-3z" fill="#FEFEFE" />
        <path transform="translate(623,1044)" d="m0 0h85l14 3 16 8 11 9 7 10 2 6 1 10v40l-5 10-14 15-12 9-2 1 1 6 14 29 13 30 4 9-1 4h-39l-5-5-15-36-9-24-2-6-29-1v72l-2 1h-39l-1-1v-91l1-107z" fill="#FEFEFE" />
        <path transform="translate(451,1044)" d="m0 0h86l15 2 12 4 11 6 10 9 6 10 3 12v40l-2 11-7 12-9 9-10 5-19 5-14 2-29 2h-11v70l-24 1h-18l-1-13v-104z" fill="#FEFEFE" />
        <path transform="translate(1182,1352)" d="m0 0h53l3 4 7 28 10 38 8 33 20 79 3 11v6l-1 1h-40l-4-13-5-23-1-2-55-1-2 13-4 23-2 4h-40l-3-2 5-21 12-48 15-57 9-34 9-35z" fill="#FEFEFE" />
        <path transform="translate(1125,1044)" d="m0 0h36l1 137 2 14 4 8 10 6 9 3h12l12-6 3-1 2-4 3-4 1-4 1-14 1-134 3-1h38v105l-1 47-1 13-4 10-6 8-8 7-15 6-21 5-8 1h-15l-22-4-14-5-11-7-7-7-7-14-3-11-1-16v-137z" fill="#FEFEFE" />
        <path transform="translate(1509,1351)" d="m0 0h65l1 1v33l-2 1-52 1h-26l1 48 63 1 1 1v32l-1 1h-64l2 47 77 1 1 1v33l-1 1h-121l-1-1v-173l1-27z" fill="#FEFEFE" />
        <path transform="translate(504,1351)" d="m0 0h44l1 1v33l-1 1-54 1h-26l1 48 62 1 2 1v32l-1 1h-64l1 47 79 1 1 1 1 14v19l-1 1h-123v-199l6-2z" fill="#FEFEFE" />
        <path transform="translate(1340,1351)" d="m0 0h36l25 3 14 3 1 1v30h-8l-24-3h-30l-9 3-8 5-5 5-2 13v78l2 15 4 6 8 6 10 4 5 1 13-1 16-6 1-1 1-65 1-1h40v90l-5 3-25 8-23 5-8 1h-22l-19-3-16-6-11-8-6-8-4-10-2-10-2-31v-53l1-30 4-13 6-9 10-10 16-8z" fill="#FEFEFE" />
        <path transform="translate(322,1351)" d="m0 0h32l21 3 13 4 1 1v31l-9-2-14-3-11-1h-16l-11 2-6 4h-2l-2 4-3 5-1 4v9l3 6 10 7 15 8 23 10 18 10 10 8 8 11 3 9v30l-4 12-8 11-9 8-10 5-18 5-16 2h-25l-21-2-20-4-4-4v-24l1-2 14 1 16 1h40l10-4 8-7 4-10v-8l-4-8-9-7-17-8-25-10-13-7-10-9-6-8-4-9-2-10v-15l2-13 4-9 6-8 7-7 12-7 13-4z" fill="#FEFEFE" />
        <path transform="translate(1285,1043)" d="m0 0h142l1 1v32l-1 1-48 2-1 101-1 63-25 1h-16l-1-7-1-158-49-1-1-1v-33z" fill="#FEFEFE" />
        <path transform="translate(900,1351)" d="m0 0h17l2 1 1 5v195l-1 1h-42l-1-69v-49l1-83z" fill="#FEFEFE" />
        <path transform="translate(850,1075)" d="m0 0h13l11 4 8 6 5 6 4 8 1 35v41l-1 13-3 7-7 8-9 6-8 3-12 1-10-3-8-6-6-7-4-9-1-15v-25l1-39 1-13 4-8 7-7 10-5z" fill="#E0DFDF" />
        <path transform="translate(1521,1075)" d="m0 0h9l11 3 8 6 8 9 3 7 1 36v40l-1 11-5 10-7 8-8 5-6 2h-16l-12-6-6-5-6-8v-98l5-8 8-7 9-4z" fill="#E0DFDF" />
        <path transform="translate(1e3 1077)" d="m0 0h37l8 4 8 9 4 8v90l-2 8-7 8-6 4-7 2-8 1h-31v-133z" fill="#E0DFDF" />
        <path transform="translate(675,1076)" d="m0 0h14l12 2 8 5 7 8 2 5v21l-3 7-7 8-8 5-4 1h-38v-61z" fill="#E0DFDF" />
        <path transform="translate(515,1076)" d="m0 0 19 1 7 3 7 8 5 11 1 5v9l-4 10-7 8-8 6-4 1h-37l-1-24v-37z" fill="#E0DFDF" />
        <path transform="translate(1208,1400)" d="m0 0 2 1 12 52 5 22v6l-36-1-2-1 4-17 6-25 6-29z" fill="#E0DFDF" />
    </svg>

}


export function IconLocationOn({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-480q33 0 56.5-23.5T560-560q0-33-23.5-56.5T480-640q-33 0-56.5 23.5T400-560q0
            33 23.5 56.5T480-480Zm0 294q122-112 181-203.5T720-552q0-109-69.5-178.5T480-800q-101 0-170.5 
            69.5T240-552q0 71 59 162.5T480-186Zm0 106Q319-217 239.5-334.5T160-552q0-150 96.5-239T480-880q127
            0 223.5 89T800-552q0 100-79.5 217.5T480-80Zm0-480Z"/>
    </svg>
}
export function IconTimer({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M360-840v-80h240v80H360Zm80 440h80v-240h-80v240Zm40 320q-74 0-139.5-28.5T226-186q-49-49-77.5-114.5T120-440q0-74
            28.5-139.5T226-694q49-49 114.5-77.5T480-800q62 0 119 20t107 58l56-56 56 56-56 56q38 50 58 107t20 119q0 74-28.5 139.5T734-186q-49
            49-114.5 77.5T480-80Zm0-80q116 0 198-82t82-198q0-116-82-198t-198-82q-116 0-198 82t-82 198q0 116 82 198t198 82Zm0-280Z" />
    </svg>
}
export function IconMap({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="m600-120-240-84-186 72q-20 8-37-4.5T120-170v-560q0-13 7.5-23t20.5-15l212-72 240 84 186-72q20-8 37 4.5t17 33.5v560q0
            13-7.5 23T812-192l-212 72Zm-40-98v-468l-160-56v468l160 56Zm80 0 120-40v-474l-120 46v468Zm-440-10 120-46v-468l-120 40v474Zm440
            -458v468-468Zm-320-56v468-468Z"/>
    </svg>

}
export function IconPlayArrow({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M320-200v-560l440 280-440 280Zm80-280Zm0 134 210-134-210-134v268Z" />
    </svg>

}
export function IconEdit({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M200-200h57l391-391-57-57-391 391v57Zm-80 80v-170l528-527q12-11 26.5-17t30.5-6q16 0 31
            6t26 18l55 56q12 11 17.5 26t5.5 30q0 16-5.5 30.5T817-647L290-120H120Zm640-584-56-56 56 56Zm-141
            85-28-29 57 57-29-28Z" />
    </svg>

}
export function IconQrCodeScanner({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M80-680v-200h200v80H160v120H80Zm0 600v-200h80v120h120v80H80Zm600 
            0v-80h120v-120h80v200H680Zm120-600v-120H680v-80h200v200h-80ZM700-260h60v60h-60v-60Zm0-120h60v60h-60v-60Zm-60
            60h60v60h-60v-60Zm-60 60h60v60h-60v-60Zm-60-60h60v60h-60v-60Zm120-120h60v60h-60v-60Zm-60
            60h60v60h-60v-60Zm-60-60h60v60h-60v-60Zm240-320v240H520v-240h240ZM440-440v240H200v-240h240Zm0-320v240H200v-240h240Zm-60
            500v-120H260v120h120Zm0-320v-120H260v120h120Zm320 0v-120H580v120h120Z" />
    </svg>

}
export function IconMoreHoriz({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M240-400q-33 0-56.5-23.5T160-480q0-33 23.5-56.5T240-560q33 0 56.5 23.5T320-480q0 33-23.5 56.5T240-400Zm240 
            0q-33 0-56.5-23.5T400-480q0-33 23.5-56.5T480-560q33 0 56.5 23.5T560-480q0 33-23.5 56.5T480-400Zm240 0q-33 0-56.5-23.5T640-480q0-33 
            23.5-56.5T720-560q33 0 56.5 23.5T800-480q0 33-23.5 56.5T720-400Z"/>
    </svg>

}

export function IconShare({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M680-80q-50 0-85-35t-35-85q0-6 3-28L282-392q-16 15-37 23.5t-45 8.5q-50 0-85-35t-35-85q0-50 35-85t85-35q24 0 45 
            8.5t37 23.5l281-164q-2-7-2.5-13.5T560-760q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35q-24 0-45-8.5T598-672L317-508q2 
            7 2.5 13.5t.5 14.5q0 8-.5 14.5T317-452l281 164q16-15 37-23.5t45-8.5q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 
            28.5-11.5T720-200q0-17-11.5-28.5T680-240q-17 0-28.5 11.5T640-200q0 17 11.5 28.5T680-160ZM200-440q17 0 
            28.5-11.5T240-480q0-17-11.5-28.5T200-520q-17 0-28.5 11.5T160-480q0 17 11.5 28.5T200-440Zm480-280q17 0 
            28.5-11.5T720-760q0-17-11.5-28.5T680-800q-17 0-28.5 11.5T640-760q0 17 11.5 28.5T680-720Zm0 520ZM200-480Zm480-280Z"/>
    </svg>

}

export function IconComment({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M880-80 720-240H160q-33 0-56.5-23.5T80-320v-480q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v720ZM160-320h594l46
            45v-525H160v480Zm0 0v-480 480Z"/>
    </svg>

}
export function IconFavorite({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="m480-120-58-52q-101-91-167-157T150-447.5Q111-500 95.5-544T80-634q0-94 63-157t157-63q52 0 99 22t81 62q34-40 81-62t99-22q94
            0 157 63t63 157q0 46-15.5 90T810-447.5Q771-395 705-329T538-172l-58 52Zm0-108q96-86 158-147.5t98-107q36-45.5 
            50-81t14-70.5q0-60-40-100t-100-40q-47 0-87 26.5T518-680h-76q-15-41-55-67.5T300-774q-60 0-100 40t-40 100q0 35 14 70.5t50
            81q36 45.5 98 107T480-228Zm0-273Z"/>
    </svg>

}
export function IconThumbUp({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M720-120H280v-520l280-280 50 50q7 7 11.5 19t4.5 23v14l-44 174h258q32 0 56 24t24 56v80q0 7-2 15t-4 15L794-168q-9 20-30
            34t-44 14Zm-360-80h360l120-280v-80H480l54-220-174 174v406Zm0-406v406-406Zm-80-34v80H160v360h120v80H80v-520h200Z" />
    </svg>

}
export function IconReport({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-280q17 0 28.5-11.5T520-320q0-17-11.5-28.5T480-360q-17 0-28.5 11.5T440-320q0 17 
            11.5 28.5T480-280Zm-40-160h80v-240h-80v240ZM330-120 120-330v-300l210-210h300l210 
            210v300L630-120H330Zm34-80h232l164-164v-232L596-760H364L200-596v232l164 164Zm116-280Z"/>
    </svg>

}

export function IconArrowForward({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="m321-80-71-71 329-329-329-329 71-71 400 400L321-80Z" />
    </svg>

}
export function IconArrowBack({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M400-80 0-480l400-400 71 71-329 329 329 329-71 71Z" />
    </svg>

}

export function IconClose({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z" />
    </svg>

}
export function IconAddPhotoAlternate({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-480ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h320v80H200v560h560v-320h80v320q0 
            33-23.5 56.5T760-120H200Zm40-160h480L570-480 450-320l-90-120-120 160Zm440-320v-80h-80v-80h80v-80h80v80h80v80h-80v80h-80Z" />
    </svg>

}
export function IconPhotoCamera({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-260q75 0 127.5-52.5T660-440q0-75-52.5-127.5T480-620q-75 0-127.5 52.5T300-440q0 75 52.5 127.5T480-260Zm0-80q-42
            0-71-29t-29-71q0-42 29-71t71-29q42 0 71 29t29 71q0 42-29 71t-71 29ZM160-120q-33 0-56.5-23.5T80-200v-480q0-33
            23.5-56.5T160-760h126l74-80h240l74 80h126q33 0 56.5 23.5T880-680v480q0 33-23.5 56.5T800-120H160Zm0-80h640v-480H638l-73-80H395l-73
            80H160v480Zm320-240Z" />
    </svg>
}
export function IconPerson({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-480q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113q0 66-47 113t-113 47ZM160-160v-112q0-34
            17.5-62.5T224-378q62-31 126-46.5T480-440q66 0 130 15.5T736-378q29 15 46.5 
            43.5T800-272v112H160Zm80-80h480v-32q0-11-5.5-20T700-306q-54-27-109-40.5T480-360q-56 0-111 13.5T260-306q-9 5-14.5
            14t-5.5 20v32Zm240-320q33 0 56.5-23.5T560-640q0-33-23.5-56.5T480-720q-33 0-56.5 23.5T400-640q0 
            33 23.5 56.5T480-560Zm0-80Zm0 400Z"/>
    </svg>
}
export function IconMenu({
    className,
    size = '24px',
    color = '#000',
    onClick = null,
    mobileMenu = null
}) {
    return <svg
        id={mobileMenu}
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path id={mobileMenu} d="M120-240v-80h720v80H120Zm0-200v-80h720v80H120Zm0-200v-80h720v80H120Z" />
    </svg>
}
export function IconDelete({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M280-120q-33 0-56.5-23.5T200-200v-520h-40v-80h200v-40h240v40h200v80h-40v520q0 33-23.5 
            56.5T680-120H280Zm400-600H280v520h400v-520ZM360-280h80v-360h-80v360Zm160 0h80v-360h-80v360ZM280-720v520-520Z"/>
    </svg>
}

export function IconSearch({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 
            184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5
            52.5T200-580q0 75 52.5 127.5T380-400Z"/>
    </svg>

}

export function ArrowDropDown({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M480-360 280-560h400L480-360Z" />
    </svg>
}

export function ArrowDropUp({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="m280-400 200-200 200 200H280Z" />
    </svg>
}
export function ArrowUpward({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        height={size}
        viewBox="0 -960 960 960"
        width={size}
        fill={color}
        onClick={onClick}
    >
        <path d="M440-160v-487L216-423l-56-57 320-320 320 320-56 57-224-224v487h-80Z" />
    </svg>
}

export function IconMarketCheckIn({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        version="1.1"
        viewBox="0 0 1600 1600"
        className={className}
        width={size}
        height={size}
        fill={color}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path transform="translate(1028,207)" d="m0 0h124l34 2 23 3 16 5 16 8 16 11 12 11 10 11 9 14 9 17 10 25 17 52 
            14 45 25 81 8 30 5 28 3 23v15l-5 34-4 15-9 20-10 19-11 14-12 14-31 31-14 11-17 12-12 7-16 8-16 7-12 3-7 
            1h-24l-31-2-21-3-19-5-21-8-21-10-14-10-12-11-11-11-4-1-10 8-17 13-13 9-16 10-19 8-19 6-26 4-13 1h-27l-23-3-24-6-13-5-15-8-17-11-27-18-10-6-5
            1-10 9-20 15-15 10-16 8-19 7-18 4-15 2-15 1h-27l-26-3-23-6-16-7-17-9-16-11-18-13-10-7h-5l-9 7-13 11-15 10-15 9-16 7-21 6-18 3-23 2-20 1-7 
            1v25l-1 127-1 297h255l2 3v121l-8 2h-248l-29-3-19-4-16-8-11-9-14-14-14-21-10-18-6-15-5-19-2-15-2-40-1-43v-357l1-65-2-7-7-9-10-11-12-16-13-23-6-12
            -7-21-4-22-1-9v-33l6-40 6-23 13-44 5-15 12-39 17-54 12-36 11-28 9-17 10-14 9-11 11-9 17-11 18-8 21-5 9-1 20-1zm-737 127-2 2-3 15-4 16-13 43-9 31-9 
            30-13 42-8 29-3 15v25l6 23 7 16 7 11 6 7 10 7 15 5 16 3h24l16-4 10-6 13-11 12-15 7-16 5-14 4-21 7-51 8-61 5-39 9-55 2-17v-10zm265 0-9 1-8 43-6 42-7 
            41-10 66-3 21-1 12v13l3 19 6 18 8 15 9 10 9 7 13 6 13 4 5 1h25l19-5 15-6 12-8 6-7 8-15 5-16 2-15 1-17v-229l-17-1zm251 0-8 1v224l2 21 3 15 6 16 7 14 
            9 10 11 7 20 8 11 3 17 1 17-3 16-6 15-9 7-6 8-10 8-13 3-10v-35l-8-64-16-116-6-43-1-5zm293 0-46 1-1 2 6 31 9 62 7 49 8 53 6 41 4 19 6 18 6 11 11 12 10 
            8 15 9 15 4h21l19-4 10-4 11-7 9-8 10-14 8-18 3-11 1-7v-20l-3-17-8-26-9-28-15-47-8-27-14-46-5-15-5-18-2-3z" fill={color} />
        <path transform="translate(1364,719)" d="m0 0 6 3 13 12 14 12 9 7 16 13 12 10 10 8 16 13 14 11 16 13 10 9 1 4-4 6-15 15-9 11-14 15-11 13-11 
            12-7 8-11 12-9 10-7 8-15 16-1 2h-2l-2 4-13 14-7 8-9 10-15 16-9 10-7 8-9 10-11 12-9 10-7 8-15 16-1 2h-2l-2 4-14 15-7 8-5 6h-2v2h-2l-2 4-15 16-9
            11-7 7-7 8-9 10-12 13-7 8-12 13-10 11-7 8-14 15-9 10-12 13-7 8-11 12-7 8-14 15-13 15-8 8-7 8-11 12-10 11-7 8-14 15-11 12-7 8-14 15-11 12-7 7-7 
            8-12 14-3 2-5-1-8-7-8-8-14-11-13-10-14-11-13-11-13-10-17-14-16-13-14-11-17-14-16-13-14-11-14-12-13-10-17-14-12-10-25-20-28-22-12-10-11-9-14-12-12-8-9-8
            5-5 11-8 10-9 28-22 13-11 13-10 16-13 17-13 13-12 9-9 6 1 16 12 18 14 16 13 33 27 10 8 16 13 14 11 10 8 3 2v2l4 2 16 13 14 11 14 12 4 2 13-16 7-7 7-8
            13-15 9-10 7-8 15-16 10-11 2-3h2l2-4 9-9 7-8 15-16 12-14 9-9 9-11 13-14 7-8 7-7 9-11 12-13 7-8 10-11 7-8 12-13 30-32 12-14 7-7 7-8 6-7h2l2-4 7-8 12-14
            12-13 7-8 12-13 13-14 1-2h2l2-4 11-12 7-8 9-10 8-8 5-6h2l2-4 16-17 12-13 13-16 7-9z" fill={color} />
        <path transform="translate(1028,207)" d="m0 0h124l31 2v1h-826l-39-1v-1z" fill="#742C0E" />
        <path transform="translate(160,727)" d="m0 0h1l1 37v108l1 233v59l-1 63h-1l-1-9-1-26-1-43v-357l1-64z" fill="#752C0E" />
        <path transform="translate(567,333)" d="m0 0h106l1 1 1 155 1 39v31l-3 10-3 1v-167l1-68-104-1z" fill="#762D0F" />
        <path transform="translate(798,339)" d="m0 0h1v221h-1l-1-9-1-24v-111l1-53z" fill="#742C0F" />
        <path transform="translate(1055,332)" d="m0 0 86 1v1l-41 1h-46z" fill="#83330F" />
        <path transform="translate(1247,553)" d="m0 0 3 3 2 5v15l-3 7-2-2z" fill="#742C0E" />
        <path transform="translate(959,561)" d="m0 0 3 3 2 8-1 7-2 5h-1l-1-6z" fill="#742C0F" />
        <path transform="translate(1178,333)" d="m0 0 7 1 1 1v18l-2-2-5-16z" fill="#752C0E" />
        <path transform="translate(402,433)" d="m0 0h1v21l-2 4h-2l2-20z" fill="#772D0E" />
    </svg>
}
export function IconWhatsapp({
    className,
    size = '24px',
    color = '#000',
    onClick = null
}) {
    return <svg
        version="1.1"
        viewBox="0 0 2044 2048"
        className={className}
        width={size}
        height={size}
        fill={color}
        onClick={onClick}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path transform="translate(1011,148)" d="m0 0 43 1 45 3 35 4 39 6 43 9 42 11 38 12 30 11 27 11 27 12 19 9 19 10 24 13 28 17 16 10 19 13 14 10 19 14 14 11 11 9 13 11 10 9 11 9 13 13 8 7 17 17 7 8 7 7 7 8 9 10 11 13 9 11 12 15 15 20 13 18 10 15 11 17 17 28 16 29 19 38 16 37 8 20 5 14v2l2 1 2 11h2l2 11h2l3 11 2 2 1 11 3 1-1 2 2 8v4h3l1 4 1 10h3v10l5 10-2 6h2l7 28h-2l2 5 1 8 1 1 1 12 1 7 2 8v8l2 7v2l1 10 1 4v9l1 14-1 3h2v11l1 2v16l1 18-1 2 1 3-1 17v30l-1 8-1 7 1 5-2 4 2 1-2 17v4l-2 1v8l1 5v8l-3 6 2 1h-3v2l3 2-4 1 1 4 2 1v2l-3 3 2 1-2 2 2 7-2 4 1 3-4 2 2 1 1 4-2 2v3l-1 3v9h-2l1 4-2 7-2 9-1 5-2 13-3 8-2 10h-2l1 5h-2l-1 11-3 9-6 17-1 5-4 10-5 15-1 5-2 1-1 6-3 8-3 7-2 5-1 5-2 1-5 15-20 40-1 4h-2l-3 9-4 8-7 12-4 8h-2l-1 6-3 3-4 9-3 3-3 6h-2l-1 5-7 10v2l-3 3-5 7v2h-2l-2 5-3 3-1 3h-3v5l-3 3h-2v3l-5 5-4 7-3 1-1 4h-2l-2 4-5 8h-2v2h-2l-2 5-3 2-1 3h-2l-2 5-2 1-4 6h-2v2h-2v2h-2l-1 4-2 1-1 3-5 5-6 7-5 5-4 5h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2l-6 5h-2v3l-8 7-5 5-3 2-1 2-3 1-1 3-5 1-5 6-1 2-3 1-1 2-3 1-2 3h-3l-1 4-4 1-2 3-3-1-1 4-6 4-1 2h-2v2h-2v2l-6 2v2l-10 7-4 4h-5v3l-3 1-1 3-3 2h-3l-1 2h-2v2l-4 2-7 6-4-1 1 3-5 3-3 1v2l-8 4h-2v2l-6 1v3l-7 4-9 6-4-1 1 3-7 2v2l-6 3-8 5-7 2-3 3-10 5h-3v2l-4 2h-3v2l-14 7-8 3-12 6-1 1h-5v2l-11 4-5 1v2h-5l-4 3-10 4-7 2-6 3h-6v2l-9 2-1 2-9 2-5 2-1-1-1 2-14 4-3-1v2h-4l-1 2-5 1-2-1-5 2-1 2-8 1-7 1-3 3h-9v2l-4 1h-3l-8 1h-2v2l-3 1h-3l-6 2-7 1-4 1-11 2-4 1-5-1-1 2h-6l-5 1-5-1-1 3v-2l-8 2h-4l-1 1h-6l-2 1v-2l-9 2-12 1-4 1-2 1v-2h-6l-2 2-4-1h-2-10-2-8l-3 1h-46l-7 1-5-1h-31l-4 1-4-1-24-1v-2h-9v-2h-2l-1 2-23-1-4-2-11-1-10-1-9-3-15-1-7-2-1-2h-11l-9-3-10-2-19-5-10-2-9-3-16-5-6-2-16-5-7-3h-3l-8-4-1-1-6-1-4-2-3-3-16-6-35-15 1 1 1 2-10-3h-3l-3-1-1-1-6-1-5-2-16-4-14-1-27 1-9 1-16 3-15 3-17 4-3 1-11 3-11 2-7 3-9 1-8 3h-8v2l-13 3-9 3-28 7-7 2-7 1-6 2-7 2-10 2-8 3-13 3-14 4-18 4-21 6-13 4-16 4-11 2-9 2-5-1-6 2h-12l-2-2-2 1-7 1-47 11-19 5h-5l1-8 18-68 18-65 16-59 21-77 14-51 27-99 3-16-4-10-16-31-8-16-14-30-16-40-13-37-10-33-11-44-8-40-6-39-4-38-2-31v-78l3-43 6-48 7-40 9-40 11-40 12-36 10-27 11-27 13-29 8-16 13-25 13-23 13-22 18-27 11-16 13-18 13-16 10-13 11-13 13-15 11-12 7-7 7-8 22-22 8-7 9-9 11-9 12-11 11-9 14-11 15-12 19-13 15-11 41-26 28-16 29-15 29-14 30-13 29-11 38-13 39-11 38-9 37-7 34-5 40-4 28-2zm860 973m-1 11m-1 12m-2 10m1 5m-4 16m-2 1m1 11m-7 6 1 2zm2 1m0 2m-3 11m-3 2v5l2-4zm3 1m-1 2m-4 6 1 3zm-1 6-2 7 2-1 2-6zm1 4m-4 5-10 34-11 32-13 34 1 3 5-12 4-9 3-9 7-18 3-10 5-14 1-7 2-1 2-11 2-5v-7zm1 6m-1 5m-35 92 1 2zm-1 2-1 5 2-1zm-2 5 1 2zm-1 2 1 2zm-1 3-1 4 2-1zm-2 4 1 2zm-2 5m-1 2 1 2zm-1 2 1 2zm-1 3m-1 1 1 2zm-1 3-1 4 2-1zm-2 4m-2 4 1 2zm-1 2 1 2zm-11 37m-102 152m-68 72m-1 1m-118 91 1 2z" fill="#45C258" />
        <path transform="translate(1011,148)" d="m0 0 43 1 45 3 35 4 39 6 43 9 42 11 38 12 30 11 27 11 27 12 19 9 19 10 24 13 28 17 16 10 19 13 14 10 19 14 14 11 11 9 13 11 10 9 11 9 13 13 8 7 17 17 7 8 7 7 7 8 9 10 11 13 9 11 12 15 15 20 13 18 10 15 11 17 17 28 16 29 19 38 16 37 8 20 5 14v2l2 1 2 11h2l2 11h2l3 11 2 2 1 11 3 1-1 2 2 8v4h3l1 4 1 10h3v10l5 10-2 6h2l7 28h-2l2 5 1 8 1 1 1 12 1 7 2 8v8l2 7v2l1 10 1 4v9l1 14-1 3h2v11l1 2v16l1 18-1 2 1 3-1 17v30l-1 8-1 7 1 5-2 4 2 1-2 17v4l-2 1v8l1 5v8l-3 6 2 1h-3v2l3 2-4 1 1 4 2 1v2l-3 3 2 1-2 2 2 7-2 4 1 3-4 2 2 1 1 4-2 2v3l-1 3v9h-2l1 4-2 7-2 9-1 5-2 13-3 8-2 10h-2l1 5h-2l-1 11-3 9-6 17-1 5-4 10-5 15-1 5-2 1-1 6-3 8-3 7-2 5-1 5-2 1-5 15-20 40-1 4h-2l-3 9-4 8-7 12-4 8h-2l-1 6-3 3-4 9-3 3-3 6h-2l-1 5-7 10v2l-3 3-5 7v2h-2l-2 5-3 3-1 3h-3v5l-3 3h-2v3l-5 5-4 7-3 1-1 4h-2l-2 4-5 8h-2v2h-2l-2 5-3 2-1 3h-2l-2 5-2 1-4 6h-2v2h-2v2h-2l-1 4-2 1-1 3-5 5-6 7-5 5-4 5h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2l-6 5h-2v3l-8 7-5 5-3 2-1 2-3 1-1 3-5 1-5 6-1 2-3 1-1 2-3 1-2 3h-3l-1 4-4 1-2 3-3-1-1 4-6 4-1 2h-2v2h-2v2l-6 2v2l-10 7-4 4h-5v3l-3 1-1 3-3 2h-3l-1 2h-2v2l-4 2-7 6-4-1 1 3-5 3-3 1v2l-8 4h-2v2l-6 1v3l-7 4-9 6-4-1 1 3-7 2v2l-6 3-8 5-7 2-3 3-10 5h-3v2l-4 2h-3v2l-14 7-8 3-12 6-1 1h-5v2l-11 4-5 1v2h-5l-4 3-10 4-7 2-6 3h-6v2l-9 2-1 2-9 2-5 2-1-1-1 2-14 4-3-1v2h-4l-1 2-5 1-2-1-5 2-1 2-8 1-7 1-3 3h-9v2l-4 1h-3l-8 1h-2v2l-3 1h-3l-6 2-7 1-4 1-11 2-4 1-5-1-1 2h-6l-5 1-5-1-1 3v-2l-8 2h-4l-1 1h-6l-2 1v-2l-9 2-12 1-4 1-2 1v-2h-6l-2 2-4-1h-2-10-2-8l-3 1h-46l-7 1-5-1h-31l-4 1-4-1-24-1v-2h-9v-2h-2l-1 2-23-1-4-2-11-1-10-1-9-3-15-1-7-2-1-2h-11l-9-3-10-2-19-5-10-2-9-3-16-5-6-2-16-5-7-3h-3l-8-4-1-1-6-1-4-2-3-3-16-6-35-15 1 1 1 2-10-3h-3l-3-1-1-1-6-1-5-2-16-4-14-1-27 1-9 1-16 3-15 3-17 4-3 1-11 3-11 2-7 3-9 1-8 3h-8v2l-13 3-9 3-28 7-7 2-7 1-6 2-7 2-10 2-8 3-13 3-14 4-18 4-21 6-13 4-16 4-11 2-9 2-5-1-6 2h-12l-2-2-2 1-7 1-47 11-19 5h-5l1-8 18-68 18-65 16-59 21-77 14-51 27-99 3-16-4-10-16-31-8-16-14-30-16-40-13-37-10-33-11-44-8-40-6-39-4-38-2-31v-78l3-43 6-48 7-40 9-40 11-40 12-36 10-27 11-27 13-29 8-16 13-25 13-23 13-22 18-27 11-16 13-18 13-16 10-13 11-13 13-15 11-12 7-7 7-8 22-22 8-7 9-9 11-9 12-11 11-9 14-11 15-12 19-13 15-11 41-26 28-16 29-15 29-14 30-13 29-11 38-13 39-11 38-9 37-7 34-5 40-4 28-2zm-18 146-39 2-40 5-35 6-40 9-42 12-34 12-29 12-27 12-38 20-24 14-25 16-17 12-19 14-16 13-10 8-15 13-12 11-13 12-22 22-7 8-9 10-9 11-12 14-10 13-14 19-13 19-14 22-14 24-14 26-15 31-14 34-11 30-12 39-9 38-7 36-5 38-3 39v81l5 51 6 37 8 38 10 37 12 36 12 31 13 29 10 21 12 22 15 26 12 19 8 13v8l-11 41-11 40-18 66-17 62-11 40-1 9 17-4 88-23 45-12 51-13 57-15 8-2 6 1 20 11 21 12 24 13 23 11 30 13 29 11 40 13 38 10 39 8 41 6 47 4h68l48-4 34-5 28-5 35-8 28-8 36-12 29-11 25-11 25-12 25-13 27-16 14-9 12-8 20-14 17-13 16-13 11-9 12-11 8-7 15-14 20-20 7-8 11-12 9-11 11-13 13-17 11-15 12-17 11-17 17-28 12-22 8-15 15-33 10-24 13-36 10-33 8-32 7-36 5-36 3-31 2-40v-39l-3-43-5-41-6-35-10-42-10-34-10-29-12-30-13-29-14-28-13-23-12-20-18-27-12-17-10-13-11-14-11-13-9-10-7-8-14-15-28-28-8-7-12-11-11-9-16-13-19-14-18-13-22-14-21-13-24-13-19-10-23-11-31-13-36-13-36-11-36-9-37-7-28-4-27-3-38-2zm878 827m-1 11m-1 12m-2 10m1 5m-4 16m-2 1m1 11m-7 6 1 2zm2 1m0 2m-3 11m-3 2v5l2-4zm3 1m-1 2m-4 6 1 3zm-1 6-2 7 2-1 2-6zm1 4m-4 5-10 34-11 32-13 34 1 3 5-12 4-9 3-9 7-18 3-10 5-14 1-7 2-1 2-11 2-5v-7zm1 6m-1 5m-35 92 1 2zm-1 2-1 5 2-1zm-2 5 1 2zm-1 2 1 2zm-1 3-1 4 2-1zm-2 4 1 2zm-2 5m-1 2 1 2zm-1 2 1 2zm-1 3m-1 1 1 2zm-1 3-1 4 2-1zm-2 4m-2 4 1 2zm-1 2 1 2zm-11 37m-102 152m-68 72m-1 1m-118 91 1 2z" fill="#FCFCFC" />
        <path transform="translate(708,611)" d="m0 0h44l16 2 12 5 10 9 9 14 12 26 8 20 8 19 13 32 11 27 19 46 4 13v10l-5 14-11 21-10 13-12 14-9 11-7 7-7 8-8 11-2 6v12l5 12 15 24 16 24 10 13 12 16 11 13 9 11 24 26 9 9 8 7 7 7 11 9 13 11 11 8 18 13 18 12 18 11 22 12 15 8 33 15 18 8 12 4h9l11-6 12-12 9-11 11-13 14-17 11-14 15-20 8-10 7-6 7-3h11l16 4 31 13 35 17 23 11 39 19 17 8 17 9 14 7 11 8 3 3 3 10v25l-4 27-5 21-8 24-8 14-11 14-14 14-14 11-15 11-21 12-16 8-14 6-17 5-23 4-22 2h-29l-23-3-34-7-30-8-44-14-49-18-30-12-24-11-22-11-23-13-21-13-22-15-19-14-14-11-16-13-13-11-11-10-8-7-10-9-40-40-7-8-12-13-7-8-14-17-11-13-13-17-14-18-13-19-11-15-11-16-12-17-11-17-9-15-13-24-12-25-9-23-7-21-6-24-4-23-1-10v-44l4-27 6-25 7-20 11-23 11-18 10-13 9-11 11-12 15-15 14-9 13-5z" fill="#FCFCFC" />
        <path transform="translate(1835,743)" d="m0 0h2l3 11 2 2 1 11 3 1-1 2 2 8v4h3l1 4 1 10h3v10l5 10-2 6h2l7 28h-2l2 5 1 8 1 1 1 12 1 7 2 8v8l2 7v2l1 10 1 4v9l1 14-1 3h2v11l1 2v16l1 18-1 2 1 3-1 17v30l-1 8-1 7 1 5-2 4 2 1-2 17v4l-2 1v8l1 5v8l-3 6 2 1h-3v2l3 2-4 1 1 4 2 1v2l-3 3 2 1-2 2 2 7-2 4 1 3-4 2 2 1 1 4-2 2v3l-1 3v9h-2l1 4-2 7-2 9-1 5-2 13-3 8-2 10h-2l1 5h-2l-1 11-3 9-6 17-1 5-4 10-5 15-1 5-2 1-1 6-3 8-3 7-2 5-1 5-2 1-5 15-20 40-1 4h-2l-3 9-4 8-7 12-4 8h-2l-1 6-3 3-4 9-3 3-3 6h-2l-1 5-7 10v2l-3 3-5 7v2h-2l-2 5-3 3-1 3h-3v5l-3 3h-2v3l-5 5-4 7-3 1-1 4h-2l-2 4-5 8h-2v2h-2l-2 5-3 2-1 3h-2l-2 5-2 1-4 6h-2v2h-2v2h-2l-1 4-2 1-1 3-5 5-6 7-5 5-4 5h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2h-2v2l-6 5h-2v3l-8 7-5 5-3 2-1 2-3 1-1 3-5 1-5 6-1 2-3 1-1 2-3 1-2 3h-3l-1 4-4 1-2 3-3-1-1 4-6 4-1 2h-2v2h-2v2l-6 2v2l-10 7-4 4h-5v3l-3 1-1 3-3 2h-3l-1 2h-2v2l-4 2-7 6-4-1 1 3-5 3-3 1v2l-8 4h-2v2l-6 1v3l-7 4-9 6-4-1 1 3-7 2v2l-6 3-8 5-7 2-3 3-10 5h-3v2l-4 2h-3v2l-14 7-8 3-12 6-1 1h-5v2l-11 4-5 1v2h-5l-4 3-10 4-7 2-6 3h-6v2l-9 2-1 2-9 2-5 2-1-1-1 2-14 4-3-1v2h-4l-1 2-5 1-2-1-5 2-1 2-8 1-7 1-3 3h-9v2l-4 1h-3l-8 1h-2v2l-3 1h-3l-6 2-7 1-4 1-11 2-4 1-5-1-1 2h-6l-5 1-5-1-1 3v-2l-8 2h-4l-1 1h-6l-2 1v-2l-9 2-12 1-4 1-2 1v-2h-6l-2 2-4-1h-2-10-2-8l-3 1h-46l-7 1-5-1h-31l-4 1-4-1-24-1v-2h-9v-2h-2l-1 2-23-1-4-2-11-1-10-1-9-3-15-1-7-2-1-2h-11l-9-3-10-2-19-5-10-2-9-3-16-5-6-2-16-5-7-3h-3l-8-4 2-2 9 2 27 9 18 5 35 9 26 6 21 4 21 3 16 2 19 3 66 4h50l39-2 28-2 38-5 37-6 41-9 34-9 35-11 31-11 27-11 29-13 23-11 19-10 22-12 22-13 22-14 22-15 18-13 13-10 14-11 11-9 13-11 20-18 17-16 16-15 7-8 15-16 12-13 11-14 10-11 8-11 14-18 24-34 10-16 12-19 16-28 7-12 8-16 14-30 6-13 4-9 2 2 6-16 3-6 2-5 3-9 7-18 3-10 5-14 2-7 2-6 1-6 2-5v-3l-5 16-1-4 5-17 8-32 7-33 4-23 3-21 4-34 3-44 1-30v-18l-1-30-4-53-6-45-5-28-3-16-3-13-9-36-7-24-2-5zm36 378m-1 11m-1 12m-2 10m1 5m-4 16m-2 1m1 11m-7 6 1 2zm2 1m0 2m-3 11m-3 2v5l2-4zm3 1m-1 2m-4 6 1 3zm-1 6-2 7 2-1 2-6zm1 4m-3 11m-1 5m-38 99 1 2zm-1 2 1 2zm-1 3-1 4 2-1zm-2 4 1 2zm-2 5m-1 2 1 2zm-1 2 1 2zm-1 3m-1 1 1 2zm-1 3-1 4 2-1zm-2 4m-2 4 1 2zm-1 2 1 2zm-11 37m-102 152m-68 72m-1 1m-118 91 1 2z" fill="#ddd" />
        <path transform="translate(602,1762)" d="m0 0h6l22 12 23 11v2l13 7-2 1-11-4h-3l-1-1-6-1-5-2-16-4-14-1-27 1-9 1-16 3-15 3-17 4-3 1-11 3-11 2-7 3-9 1-8 3h-8v2l-13 3-9 3-28 7-7 2-7 1-6 2-7 2-10 2-8 3-13 3-14 4-18 4-21 6-13 4-16 4-11 2-9 2-5-1-6 2h-12l-1-4 43-12 55-14 52-14 43-11 41-11 43-11 41-11 42-11z" fill="#ddd" />
        <path transform="translate(717,1813)" d="m0 0 9 2 5 2-3 2-6-1-4-2z" fill="#ddd" />
        <path transform="translate(709,1812)" d="m0 0 6 1-2 2z" fill="#ddd" />
        <path transform="translate(701,1809)" d="m0 0 5 1-3 1z" fill="#ddd" />
        <path transform="translate(696,1807)" d="m0 0 5 1-3 1z" fill="#ddd" />
        <path transform="translate(670,1796)" d="m0 0 4 1-1 2z" fill="#ddd" />
        <path transform="translate(691,1805)" d="m0 0h3l-1 2z" fill="#ddd" />
        <path transform="translate(683,1802)" d="m0 0 3 1z" fill="#ddd" />
        <path transform="translate(667,1795)" d="m0 0 3 1z" fill="#ddd" />
        <path transform="translate(1855,804)" d="m0 0h2l-1 2z" fill="#ddd" />
        <path transform="translate(689,1804)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(687,1803)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(681,1801)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(679,1800)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(677,1799)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(653,1792)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(1872,1141)" d="m0 0 2 1z" fill="#ddd" />
        <path transform="translate(1870,874)" d="m0 0" fill="#ddd" />
        <path transform="translate(1851,789)" d="m0 0" fill="#ddd" />
        <path transform="translate(940,1867)" d="m0 0" fill="#ddd" />
        <path transform="translate(1125,1866)" d="m0 0" fill="#ddd" />
        <path transform="translate(231,1863)" d="m0 0" fill="#ddd" />
        <path transform="translate(715,1814)" d="m0 0" fill="#ddd" />
        <path transform="translate(708,1811)" d="m0 0" fill="#ddd" />
        <path transform="translate(695,1806)" d="m0 0" fill="#ddd" />
        <path transform="translate(1516,1717)" d="m0 0" fill="#ddd" />
        <path transform="translate(1523,1713)" d="m0 0" fill="#ddd" />
        <path transform="translate(1568,1678)" d="m0 0" fill="#ddd" />
        <path transform="translate(1594,1656)" d="m0 0" fill="#ddd" />
        <path transform="translate(1607,1644)" d="m0 0" fill="#ddd" />
        <path transform="translate(1704,1539)" d="m0 0" fill="#ddd" />
        <path transform="translate(1716,1523)" d="m0 0" fill="#ddd" />
        <path transform="translate(267,1447)" d="m0 0" fill="#ddd" />
        <path transform="translate(1868,1168)" d="m0 0" fill="#ddd" />
        <path transform="translate(1872,1128)" d="m0 0" fill="#ddd" />
        <path transform="translate(1876,1101)" d="m0 0" fill="#ddd" />
        <path transform="translate(1852,793)" d="m0 0" fill="#ddd" />
        <path transform="translate(1848,777)" d="m0 0" fill="#ddd" />
        <path transform="translate(1847,775)" d="m0 0" fill="#ddd" />
        <path transform="translate(1838,744)" d="m0 0" fill="#ddd" />
        <path transform="translate(1824,708)" d="m0 0" fill="#ddd" />
    </svg>

}

